import { IMAGES } from "@/lib/constants";

const SPANS = [
    "lg:col-span-6 lg:row-span-2",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-4",
    "lg:col-span-4",
    "lg:col-span-4",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-4",
    "lg:col-span-4",
    "lg:col-span-4",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-3",
    "lg:col-span-6",
    "lg:col-span-3",
    "lg:col-span-3",
];

const GalleryItem = ({ src, span, index }) => (
    <div
        data-testid={`gallery-item-${index}`}
        className={`group relative overflow-hidden border border-black/10 reveal col-span-2 lg:col-span-3 ${span}`}
    >
        <img
            src={src}
            alt={`Trabalho Lavlimpar — limpeza técnica de cozinhas industriais ${index + 1}`}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-all duration-700"
        />
        <div className="absolute bottom-4 left-4 right-4">
            <span className="font-display text-base md:text-lg font-black tracking-tight text-white drop-shadow-lg">
                / {String(index + 1).padStart(2, "0")}
            </span>
        </div>
    </div>
);

const SectionHeader = () => (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-16">
        <div className="lg:col-span-5 reveal">
            <div className="flex items-center gap-3 mb-6">
                <span className="block w-12 h-px bg-[#2E7D5B]" />
                <span className="label-tag">Galeria</span>
            </div>
            <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-black uppercase tracking-tighter leading-[0.95] text-[#0A0A0A]">
                Trabalhos<br />
                <span className="text-[#2E7D5B]">recentes.</span>
            </h2>
        </div>
        <div className="lg:col-span-6 lg:col-start-7 reveal flex items-end">
            <p className="text-base md:text-lg text-[#0A0A0A]/60 leading-relaxed font-light">
                Uma seleção de intervenções reais em hottes, condutas, motores
                e cozinhas industriais. Cada projeto é único — o nosso
                compromisso com a qualidade técnica não.
            </p>
        </div>
    </div>
);

const Gallery = () => (
    <section
        id="galeria"
        data-testid="gallery-section"
        className="relative py-24 md:py-32 px-6 md:px-12 lg:px-24 bg-white"
    >
        <div className="max-w-7xl mx-auto">
            <SectionHeader />
            <div className="grid grid-cols-2 lg:grid-cols-12 auto-rows-[200px] md:auto-rows-[280px] gap-3 md:gap-4">
                {IMAGES.gallery.map((src, i) => (
                    <GalleryItem
                        key={src}
                        src={src}
                        span={SPANS[i % SPANS.length]}
                        index={i}
                    />
                ))}
            </div>
        </div>
    </section>
);

export default Gallery;
